import { useEffect, useMemo } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { subscriptionPingActions } from "../../actions";
import { subscriptionPingsConstants } from "../../constants/subscription_pings_constants";
import { isDateExpired } from "../../utils/isDateExpired";
import { dateTimeFormatter } from "../../utils";

const useSubscriptionPanelHook = () => {
    const { current_organization, subscription_ping } = useSelector(
        (state) => ({
            current_organization: state.organization.current_organization,
            subscription_ping: state.subscription_ping.subscription_ping
        }),
        shallowEqual
    );
    const { id:organization_id, type, subscription, last_subscription } = current_organization || {};
    const {current_period_end, organization_name, hidden, loading} = subscription_ping || {};
    const dispatch = useDispatch();

    useEffect(() => {
        if(organization_id){
            const onSuccess = (response) => {
                dispatch({ type: subscriptionPingsConstants.SUBSCRIPTION_PING_ADD, payload: response.data.data })
            }
            const onError = (response) => {
            }
            const onBefore = () => {
                dispatch({ type: subscriptionPingsConstants.SUBSCRIPTION_PING_LOADING })
            }
            const onFinally = () => {
                dispatch({ type: subscriptionPingsConstants.SUBSCRIPTION_PING_LOADED })
            }
            dispatch(subscriptionPingActions.getSubscriptionPing({organization_id, onSuccess, onError, onBefore, onFinally}));
        }
    }, [organization_id])

    const handleCloseSubscriptionPanel = () => {
        if(organization_id === null) return () => {}


        const onSuccess = (response) => {
            console.log(response)
            dispatch({ type: subscriptionPingsConstants.SUBSCRIPTION_PING_RESET })
        }

        dispatch(subscriptionPingActions.hideSubscriptionPing({organization_id, onSuccess}))
    }

    const isEndedSubscription = useMemo(() => {
        return isDateExpired(current_period_end) || type === 'expired' || (subscription === null)
    },[current_period_end, type, last_subscription])

    const display_text = useMemo(() => {
        if(isEndedSubscription){
            return 'Heads up! Your Upprovall+ subscription has ended. Please contact support to renew your subscription.'
        } else {
            return `Your Upprovall+ subscription for ${organization_name} will end on ${dateTimeFormatter(current_period_end)}. Contact Support for renewal.`
        }
    },[subscription_ping, isEndedSubscription, organization_name])

    const is_hidden = useMemo(() => {
        return (hidden || !subscription_ping) && (!isEndedSubscription || last_subscription === null) || loading
    },[subscription_ping, subscription, last_subscription, isEndedSubscription, loading])

    return {display_text, isEndedSubscription, is_hidden, handleCloseSubscriptionPanel}
}

export default useSubscriptionPanelHook